import PropTypes from 'prop-types'
import { useEffect } from 'react'
import Preview from 'features/creative/preview/Preview'
import TextInput from 'components/form/TextInput'
import { useDispatch, useSelector } from 'react-redux'
import {
  reset,
  setText,
} from 'features/creative/add/asset/additionalTitleSlice'
import ErrorText from 'components/form/ErrorText'
import { inactiveAsset } from 'features/creative/add/build/buildCreativeSlice'
import Button from 'components/form/Button'

const AdditionalTitle = ({ disabled, errors }) => {
  const dispatch = useDispatch()
  const { text } = useSelector(state => state.creative.assets.additionalTitle)

  useEffect(
    () => () => {
      dispatch(reset())
    },
    [dispatch]
  )

  const onChangeTitle = v => {
    dispatch(setText(v))
  }

  return (
    <div className="cont_material">
      <div className="group_material">
        <div className="box_material">
          <strong className="subtit_subject2">
            텍스트형 &gt; 추가제목
            <Button
              size="small"
              disabled={disabled}
              onClick={() => {
                dispatch(inactiveAsset('additionalTitle'))
              }}>
              삭제
            </Button>
          </strong>
          <div className="inner_material">
            <div className="material_item">
              <div className="tit_itemwrap">
                <strong className="tit_item">추가제목</strong>
              </div>
              <div className="desc_item">
                <TextInput
                  value={text}
                  trim
                  onValueChange={onChangeTitle}
                  placeholder="추가제목을 입력하세요"
                  maxLength={24}
                  disabled={disabled}
                  error={errors?.text}
                />
                <ErrorText error={errors?.text} />
              </div>
            </div>
          </div>
        </div>
        <Preview type="ADDITIONAL_TITLE" data={{ text }} />
      </div>
    </div>
  )
}

export default AdditionalTitle

AdditionalTitle.propTypes = {
  disabled: PropTypes.bool.isRequired,
  errors: PropTypes.shape({
    text: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired,
  }),
}
